import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { Polish } from '@/languages/polish';
import { English } from '@/languages/english';

Vue.use(VueI18n);

const messages = {
    en: English,
    pl: Polish,
};

export const i18n = new VueI18n({ locale: 'pl', fallbackLocale: 'en', messages });
